/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class FormatterProviderAPI
 * @hideconstructor
 *
 * @classdesc implementation of the FormatterProviderAPI interface.
 */
define([], () => {

	class FormatterProviderAPI {

		/**
		 * @function FormatterProviderAPI#destroy
		 * @description Used to destroy the FormatterProviderAPI object
		 */
		destroy() {}

		/**
		 * @function FormatterProviderAPI#format
		 * @description Formats a value using a specification
		 * @param {String || Number} value the value to format
		 * @param {Object} spec that specifies how the value is to be formatted
		 * @return {String} value formatted as specified in spec
		 */
		format(/* value, spec */) {}
	}

	return FormatterProviderAPI;
});